import React from "react";
import { Link } from "react-router-dom";

import AppConfig from "../../AppConfig";
import classNames from "./Logo.module.scss";

export default function Logo({ url }) {
	const mainUrl = url || AppConfig.baseUrl + "app/main/";

	return (
		<Link to={mainUrl} className={classNames.root}>
			<div className={classNames.logo}>
				<img src={require("../../assets/images/app-logo-text.svg")} alt="..." />
			</div>
		</Link>
	);
}
